import React from 'react';
import { Link } from 'react-router-dom';

function Footer(props) {
    return(
    <div className="footer">
        <div className="container">
            <div className="row justify-content-center">             
                <div className="col-4 offset-1 col-sm-2">
                    <h5>Links</h5>
                    <ul className="list-unstyled">
                        <li><Link to="/home">Home</Link></li>
                        <li><Link to="/aboutus">About us</Link></li>
                        <li><Link to="/menu">Menu</Link></li>
                        <li><Link to="/contactus">Contact Us</Link></li>
                    </ul>
                </div>
                <div className="col-7 col-sm-5">
                    <h5>Our Address</h5>
                    <address>
                    3/376-B,Arafa Shoping Complex,Opp.Edathiruthy Co-operative Bank<br />
                            P.O Edathiruthy,Thrissur-680703<br />
                            Kerala, India<br />
                            <i className="fa fa-phone"></i>: +917025812997<br />
                            <i className="fa fa-envelope"></i>: <a href="mailto:wilbrogreenenergy@gmail.com">wilbrogreenenergy@gmail.com</a>
                            </address>
                </div>
                <div className="col-12 col-sm-4 align-self-center">
                    <div className="text-center">
                        <a className="btn btn-social-icon btn-facebook" href="http://www.facebook.com/profile.php?id="><i className="fa fa-facebook"></i></a>
                        <a className="btn btn-social-icon btn-instagram" href="https://www.instagram.com/wilbrogreenenergy/?hl=en"><i className="fa fa-instagram"></i></a>
                        <a className="btn btn-social-icon btn-google" href="https://www.youtube.com/channel/UCCgn7k8Yzg3T7nJYWaVGh_A"><i className="fa fa-youtube-play"></i></a>
                        <a className="btn btn-social-icon" href="mailto:wilbrogreenenergy@gmail.com"><i className="fa fa-envelope-o"></i></a>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">             
                <div className="col-auto">
                    <p>© Copyright 2022 Wilbro Green Energy</p>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Footer;